module.exports = __webpack_public_path__ + "img/down_bg.8768ec98.png";